<template>
  <div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-center logo">
            <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/logo-tokiomarine.svg" alt="Tokio Marine Seguradora  - Consulta Integrações"
              title="Tokio Marine Seguradora  - Consulta Integrações">
          </div>
        </div>
      </div>
    </header>
    <section class="banner">
      <span></span>
      <!-- <h2>BEM VINDO(A) AO</h2> -->
      <h1>CONSULTA INTEGRAÇÕES</h1>
      <hr class="divider">
    </section>
    <nav>
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <button :class="{ active: isActive[0] }" @click.prevent="toggleButton(0)" class="me-4">CORRETOR</button>
            <button :class="{ active: isActive[1] }" @click.prevent="toggleButton(1)">OPERADORA</button>
            <!-- <router-link to="/consulta-integracoes/corretor">Corretor</router-link>
          <router-link to="/consulta-integracoes/operadora">Operadora</router-link> -->
          </div>
        </div>
      </div>
    </nav>
    <main>
      <!-- <router-view></router-view> -->
      <!-- <router-view name="toda2"></router-view> -->
      <component :is="currentComponent"></component>
    </main>
    <footer>© Tokio Marine 2024 - Todos os direitos reservados.</footer>
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentComponent: null,
      isActive: [true, false]
    };
  },

  methods: {
    getParametro() {
      if (this.$route.query.parametro == "col") {
       document.querySelector("header").classList.add("col");
       document.querySelector(".banner").classList.add("col");
      }
    },
    changeComponent(componentName) {
      this.currentComponent = () => import(`./${componentName}.vue`);
    },

    toggleButton(index) {
      this.isActive = this.isActive.map((_, i) => i === index);

      if (index === 0) {
        this.changeComponent('Corretores')
      } else {
        this.changeComponent('Operadora')
      }
    }
  },

  watch: {
    $route(to) {
      console.log(this.$route.path)
      if (to.path === '/consulta-integracoes/corretor') {
        console.log("Corretor")
        this.currentComponent = () => import('./Corretores.vue');
      } else if (to.path === '/consulta-integracoes/operadora') {
        console.log("Operadora")
        this.currentComponent = () => import('./Operadora.vue');
      }
    }
  },
  created() {
    //this.currentComponent = () => import(`.${this.$route.path}.vue`);
  },
  mounted() {
    this.changeComponent('Corretores');
    document.querySelector("body").classList.add("consulta");
    this.getParametro();
  },
  computed: {
    parametro() {
      return this.$route.query.parametro;
    }
  }
};
</script>
<style>
@import '/massificados/corporativo/gerenciador-parceiros-ui/consulta/css/consulta.css';
</style>